import script from "./ModalAddJugadorTorneo.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalAddJugadorTorneo.vue?vue&type=script&setup=true&lang=ts"

import "./ModalAddJugadorTorneo.vue?vue&type=style&index=0&id=a82f7300&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a82f7300"]])

export default __exports__